import React from "react";
import { store, persistor } from "./store/store";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import './fonts/YogaSansPro.otf';
import './fonts/YogaSansProLight.otf';
import './fonts/YogaSansProThin.otf';

import 'react-toastify/dist/ReactToastify.css';
import "./index.css";

import router from './routes/router';
import DomainGatekeeper from './Components/Common/DomainGatekeeper';  

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <DomainGatekeeper>
        <RouterProvider router={router} />
      </DomainGatekeeper>
    </PersistGate>
  </Provider>
);

reportWebVitals();


// import React from "react";
// import { store, persistor } from "./store/store";
// import ReactDOM from "react-dom/client";
// import reportWebVitals from "./reportWebVitals";
// import { RouterProvider } from "react-router-dom";
// import { Provider } from "react-redux";
// import { PersistGate } from "redux-persist/integration/react";

// import './fonts/YogaSansPro.otf';
// import './fonts/YogaSansProLight.otf';
// import './fonts/YogaSansProThin.otf';

// import 'react-toastify/dist/ReactToastify.css';
// import "./index.css";

// import router from './routes/router';



// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <Provider store={store}>
//     <PersistGate persistor={persistor}>
//       <RouterProvider router={router}/>  
//     </PersistGate>
//   </Provider>
// );

// reportWebVitals();
